var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGrin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.01 14.85l.13.225A2.15 2.15 0 0012 16.15h0a2.15 2.15 0 001.86-1.075l.13-.225H10.01zm-.538-4.143a.85.85 0 11-.944-1.414.85.85 0 01.944 1.414zM6.528 3.81a9.85 9.85 0 1110.944 16.38A9.85 9.85 0 016.528 3.81zm.944 14.966a8.15 8.15 0 109.056-13.553 8.15 8.15 0 00-9.056 13.553zM9 13.15h6a.85.85 0 01.85.85 3.85 3.85 0 01-7.7 0 .85.85 0 01.85-.85zm5.528-3.857a.85.85 0 11.944 1.414.85.85 0 01-.944-1.414z",
    fill: "#333",
    stroke: "#fff",
    strokeWidth: 0.3
  })));
}

export default SvgIconGrin;